const defaultState = {
  customerGroups: null,
  error: null,
  fetching: false,
  fetched: false
};

const getCustomerGroupsReducer = (state = defaultState, action) => {
  switch (action.type) {
    case 'CUSTOMER_GROUPS_FETCH_PENDING': {
      return {
        ...state, error: null, fetching: true
      };
    }
    case 'CUSTOMER_GROUPS_FETCH_FULFILLED': {
      return {
        ...state, fetching: false, fetched: true, error: null, customerGroups: action.payload.data
      };
    }
    case 'CUSTOMER_GROUPS_FETCH_REJECTED': {
      return {
        ...state,
        fetching: false,
        fetched: false,
        customers: null,
        error: action.payload
      };
    }
    default: {
      break;
    }
  }

  return state;
};

export default getCustomerGroupsReducer;


// WEBPACK FOOTER //
// ./src/reducers/getCustomerGroups.js